// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__J4MPn","tuyaListBody":"tuyaListBody__tTUq3"};